module.exports = __webpack_public_path__ + "static/media/pragmatic2000.bdfd8348.webp";